import axios from 'axios'
// URL de la API
const baseURL = process.env.VUE_APP_BASE_URL_API

// Objeto axios de la api de Recaudacion
const api = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  //timeout: 10000, // 10 segundos de espera
})
const apiFiles = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
  timeout: 0,
})

export default {
  /**
   * @name getRecaudacion
   * @description Obtienen una lista de Recaudacions
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  getRecaudacion(jwt, params) {
    api.defaults.headers.common['Authorization'] = 'Bearer ' + jwt

    if (params != null) {
      return api.get('recaudacion/' + params)
    }
    return api.get('recaudacion/')
  },

  /**
   * @name postRecaudacion
   * @description Se crea el Recaudacion
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  postRecaudacion(jwt, body) {
    api.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return api.post('recaudacion/crear/', body)
  },

  /**
   * @name putRecaudacion
   * @description Se actualiza el Recaudacion
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  putRecaudacion(jwt, body, id) {
    api.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return api.put('recaudacion/edit/' + id, body)
  },
  /**
   * @name deleteRecaudacion
   * @description Se actualiza el Recaudacion
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  deleteRecaudacion(jwt, body, id) {
    console.log(body)
    api.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return api.delete('recaudacion/' + id + '/' + body.rec_motivo_cancela, body)
  },
  /**
   * @name getRecaudacion
   * @description Obtienen una lista de Recaudacions
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  getRecaudacionFile(jwt, params) {
    api.defaults.headers.common['Authorization'] = 'Bearer ' + jwt

    if (params != null) {
      return api.get('recaudacionfile/' + params)
    }
    return api.get('recaudacionfile/')
  },
  /**
   * @name postRecaudacion
   * @description Se crea el Recaudacion
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  postRecaudacionFile(jwt, body, id) {
    apiFiles.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return api.post('recaudacionfile/' + id, body)
  },
  /**
   * @name deleteRecaudacionFile
   * @description Se actualiza el Recaudacion
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  deleteRecaudacionFile(jwt, body, id) {
    //console.log(body)
    //console.log(id)
    api.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return api.put('recaudacionfile/' + id + '/', body)
  },
  /**
   * @name putImpRecaudacion
   * @description Se actualiza el Recaudacion a REV
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  putImpRecaudacion(jwt, body, id) {
    api.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return api.put('recaudacion/imprime/' + id, body)
  },
  /**
   * @name putFinRecaudacion
   * @description Se actualiza el Recaudacion a REV
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  putFinRecaudacion(jwt, body, id) {
    api.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return api.put('recaudacion/finaliza/' + id, body)
  },
  /**
   * @name putRechazaRecaudacion
   * @description Se actualiza el Recaudacion a REV
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  putRechazaRecaudacion(jwt, body, id) {
    api.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return api.put('recaudacion/rechaza/' + id, body)
  },
  /**
   * @name putActivaRecaudacion
   * @description Se actualiza el Recaudacion a REV
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  putActivaRecaudacion(jwt, body, id) {
    api.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return api.put('recaudacion/activa/' + id, body)
  },
}
